import React from "react";
import { Checkbox, styled, Typography, TypographyProps } from "@mui/material";
import theme from "Theme/AppTheme";

export const customFilterSelectStyles = {
    container: (provided) => ({
        ...provided,
        backgroundColor: theme.palette.lightgray.main,
        flex: 1,
        cursor: "pointer",
        marginBottom: theme.spacing(0.5),
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: "0",
        flex: "none",
    }),
    singleValue: () => ({
        color: theme.palette.gray[500],
        fontSize: "14px",
        fontWeight: theme.typography.fontWeightMedium,
    }),
    dropdownIndicator: () => ({
        padding: theme.spacing(0.25),
        color: theme.palette.gray[500],
        display: "flex",
        alignItems: "center",
    }),
    input: (provided) => ({
        ...provided,
        margin: 0,
    }),
};

export const FilterCheckbox = styled(Checkbox)(({ theme }) => ({
    color: theme.palette.gray[300],
    maxHeight: "28px",
}));

// Helper to extract text from children
const getText = (child: React.ReactNode): string => {
    if (typeof child === "string" || typeof child === "number")
        return String(child);
    if (Array.isArray(child)) return child.map(getText).join("");
    if (React.isValidElement(child)) return getText(child.props.children);
    return "";
};

export const FilterLabel: React.FC<TypographyProps> = ({
    children,
    sx = {},
    ...props
}) => {
    const text = getText(children).replace(/[ _]/g, "");
    return (
        <Typography
            component="div"
            data-testid={`filter-title-${text}`}
            sx={{
                fontWeight: theme.typography.fontWeightSemibold,
                marginBottom: theme.spacing(1),
                fontSize: "14px",
                color: theme.palette.gray[700],
                display: "flex",
                alignItems: "center",
                gap: theme.spacing(1),
                ...sx,
            }}
            {...props}
        >
            {children}
        </Typography>
    );
};
